import {
  enableEncryptionMiddleware,
  postSendRecoveryCodeMiddleware,
  settingTwoFactor,
  verifySettingMFA,
} from "../services/api"
import { useAppSelector } from "hooks/useApp"
import Button from "components/Button/Button"
import { configureStore } from "stores/configureStore"
import { openModal, closeModal } from "reducers/modal"
import { downLoadBackUpKey, isValidPhone, umamiTracking } from "helpers/utils"
import { EVENT } from "constants/events"
import SwitchButtonDefault from "components/SwitchButton/SwitchButtonDefault"
import { EnableEncryptionRequest, MFAMethod, UserInfo } from "../types"
import { useBoolean, useString, useWindowSize } from "helpers/hooks"
import YesNoModal from "../molecules/ConfirmationModal"
import Typography from "components/Typography"
import { ReactComponent as EncryptionLockIcon } from "assets/images/icons/enable-encryption-icon.svg"
import ModalCustom from "components/ModalCustom"
import FormInputCard from "../molecules/FormInputCard"
import InputDefault from "components/Input/InputDefault"
import { encryptionController } from "controllers/EncryptionController"
import { setUserInfoAction } from "../stores/actions"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import { useState } from "react"
import { isEmpty } from "lodash"
import { STATUS_RESPONSE } from "types"
import { ReactComponent as IconExport } from "assets/images/icons/export.svg"
import { encryptionHelper } from "helpers/encryption"
import { Stores, updateData } from "services/indexedDB"
import { endLoading, startLoading } from "reducers/loading"
import Axios from "axios"
import RecoveryModal from "../molecules/RecoveryModal"
import { MESSENGER_NOTIFICATION } from "constants/messenger"
import { GenerateNewRecoveryCodeModal } from "../molecules/GenerateNewRecoveryCodeModal"
import { encryptionGCMHelper } from "helpers/encryption-gcm"
import { WarningSecurityCodeAndPhoneNumberModal } from "pages/layout/modal/WarningSecurityCodeAndPhoneNumberModal"
import InputPhone from "components/Input/InputPhone"
import { STATUS_INPUT } from "components/Input/types"
import { useChangeLabelStatusInputPasswordAndConfirm } from "../auth.hook"
import { setUserMasterKey, setUserVaultKey } from "helpers/local_storage"
interface TwoFactorFormProps {
  handleSubmit: (type: "enable" | "disable", method: MFAMethod) => void
  userInfo: UserInfo
}
interface EnableDataEncryptionModalProps {
  handleEnableDataEncryption: (
    password: string,
    phoneNumber: string,
    securityCode: string
  ) => void
  onCloseModal: () => void
}
const EnableTwoFactorForm = (props: TwoFactorFormProps) => {
  const { handleSubmit, userInfo } = props
  // const openEnableSMSOTPModal = useBoolean()

  const onDisableTwoFactor = (method: MFAMethod) => () => {
    handleSubmit("disable", method)
    closeModal()
  }

  const openWarningModal = (method: MFAMethod) => {
    const methodText =
      method === MFAMethod.email ? "email" : "authenticator app"
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: `This reduces the security level of your account and is not recommended.`,
            label: `Disable 2FA by ${methodText}`,
            content: `Are you sure you want to continue?`,
            onSubmit: onDisableTwoFactor(method),
            titleButton: `Yes, Disable 2FA`,
            styleTitle: {
              textAlign: "center",
            },
          },
        },
      })
    )
  }

  const onSwitchMFAByAuthenticatorApp = () => {
    if (userInfo.mfaMethods?.includes(MFAMethod.authenticatorApp)) {
      openWarningModal(MFAMethod.authenticatorApp)
    } else {
      handleSubmit("enable", MFAMethod.authenticatorApp)
    }
  }

  // const onSwitchMFABySMS = () => {
  //   const enableSMS = userInfo.mfaMethods?.includes(MFAMethod.sms)
  //     ? "disable"
  //     : "enable"

  //   const hasPhone = userInfo.phone_number ? true : false
  //   if (!hasPhone) {
  //     configureStore.dispatch(
  //       openModal({
  //         type: "Delete",
  //         props: {
  //           deleteModal: {
  //             title: `To enable SMS OTP, you need to add a phone number to your account first.`,
  //             label: `Phone number required`,
  //             content: "",
  //             onSubmit: () => {
  //               closeModal()
  //               pushTo(PATH.changePhoneNumber, undefined, { tab: 2 })
  //             },
  //             titleButton: `Add phone number`,
  //             styleTitle: {
  //               textAlign: "center",
  //             },
  //             colorYellowButton: true,
  //           },
  //         },
  //       })
  //     )
  //     return
  //   }
  //   if (enableSMS === "disable") {
  //     configureStore.dispatch(
  //       openModal({
  //         type: "Delete",
  //         props: {
  //           deleteModal: {
  //             title: `This reduces the security level of your account and is not recommended.`,
  //             label: `Disable SMS OTP`,
  //             content: `Are you sure you want to continue?`,
  //             onSubmit: () => onSubmitMFABySMS("disable"),
  //             titleButton: `Yes, Disable 2FA`,
  //             styleTitle: {
  //               textAlign: "center",
  //             },
  //           },
  //         },
  //       })
  //     )
  //     return
  //   }
  //   if (Boolean(userInfo.is_phone_verified)) {
  //     onSubmitMFABySMS("enable")
  //     return
  //   }
  //   openEnableSMSOTPModal.setValue(true)
  // }

  // const onSubmitMFABySMS = (type: "enable" | "disable") => {
  //   settingTwoFactor(type, MFAMethod.sms)
  //     .then((res) => {
  //       if (type === "disable") {
  //         closeModal()
  //         toast(
  //           <LabelNotificationPage
  //             messenger={MESSENGER_NOTIFICATION.DISABLED_SMS_OTP_SUCCESS}
  //             type="success"
  //           />
  //         )
  //         return
  //       }
  //       toast(
  //         <LabelNotificationPage
  //           messenger={MESSENGER_NOTIFICATION.ENABLE_SMS_OTP_SUCCESS}
  //           type="success"
  //         />
  //       )
  //     })
  //     .catch((error) => {
  //       const message = error.response?.data?.message ?? "Failed to disable"
  //       toast(<LabelNotificationPage messenger={message} type="error" />)
  //     })
  // }

  // const onSubmitEnableSMSOTPModal = (newCode: string) => {
  //   postVerifyPhoneNumberMiddleware({
  //     code: newCode,
  //   })
  //     .then(() => {
  //       onSubmitMFABySMS("enable")
  //       openEnableSMSOTPModal.setValue(false)
  //     })
  //     .catch((error) => {
  //       const message = error.response?.data?.message ?? "Failed to disable."
  //       toast(<LabelNotificationPage messenger={message} type="error" />)
  //     })
  // }

  return (
    <div>
      <p className="text-sm text-black font-semibold mb-1">
        Two-factor authentication
      </p>
      <p className="text-brown">
        Protect your account with two-factor authentication (2FA). During login,
        you'll need a code in addition to your email and password to verify your
        identity.
      </p>
      <div className="mt-2 mb-[12px] border border-[#E4E4E4] rounded-[6px]">
        <div className="flex flex-col pb-[10px] pt-[10px] pl-[12px] pr-[12px] border-b border-[#E4E4E4]">
          <div className="flex items-center justify-between">
            <p className="text-sm text-black font-semibold">Email OTP</p>
            <div className="pt-[3px] pb-[3px] pl-[8px] pr-[8px] bg-green_opacity_015 rounded-[20px]">
              <p className="text-[#56A012] text-[12px] font-semibold">
                Enabled
              </p>
            </div>
          </div>
          <p className="text-brown mt-[4px]">
            By default, you'll receive authentication codes via email for
            account security and verification.
          </p>
        </div>

        <div className="flex flex-col pb-[10px] pt-[10px] pl-[12px] pr-[12px]">
          <div className="flex items-center justify-between">
            <p className="text-sm text-black font-semibold">
              Google Authenticator
            </p>
            <SwitchButtonDefault
              checked={userInfo.mfaMethods?.includes(
                MFAMethod.authenticatorApp
              )}
              onChange={onSwitchMFAByAuthenticatorApp}
            />
          </div>
          <p className="text-brown mt-[4px] mb-[4px]">
            Use Google Authenticator to generate secure authentication codes
            directly from your device, providing an extra layer of protection
            for your account.
          </p>
          <div className="flex items-center">
            <div className="flex items-center mr-[24px]">
              <a
                href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                target="_blank"
                rel="noreferrer"
                className="flex items-center text-[14px] text-[#0A5AF5] font-[400]"
              >
                <IconExport className="mr-[6px]" />
                IOS app
              </a>
            </div>
            <div className="flex items-center">
              <a
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=vi"
                target="_blank"
                rel="noreferrer"
                className="flex items-center text-[14px] text-[#0A5AF5] font-[400]"
              >
                <IconExport className="mr-[6px]" />
                Android app
              </a>
            </div>
          </div>
        </div>
        {/* <div className="flex flex-col pb-[10px] pt-[10px] pl-[12px] pr-[12px] border-t border-[#E4E4E4]">
          <div className="flex items-center justify-between">
            <p className="text-sm text-black font-semibold">SMS OTP</p>
            <SwitchButtonDefault
              checked={userInfo.mfaMethods?.includes(MFAMethod.sms)}
              onChange={onSwitchMFABySMS}
            />
          </div>
          <p className="text-brown mt-[4px]">
            Receiving authentication code via SMS.
          </p>
        </div> */}
      </div>
      {/* {openEnableSMSOTPModal.value ? (
        <EnableAndVerifySMSOTPModal
          onCloseModal={() => openEnableSMSOTPModal.setValue(false)}
          onClickSubmit={onSubmitEnableSMSOTPModal}
          userInfo={userInfo}
        />
      ) : null} */}
    </div>
  )
}

const EnableDataEncryptionModal = (props: EnableDataEncryptionModalProps) => {
  const { handleEnableDataEncryption, onCloseModal } = props
  const { statusInputPassword, getStatusInputPassword } =
    useChangeLabelStatusInputPasswordAndConfirm()

  const password = useString()
  const phone = useString("")
  const securityCode = useString("")

  const handleChangePhoneNumber = (value) => {
    phone.setValue(value)
  }
  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }
  const handleChangeInput = (event) => {
    password.setValue(event.target.value)
    getStatusInputPassword(event.target.value)
  }
  const isValidPhoneNumber = isValidPhone(phone.value)

  const handleDisableButton = () => {
    if (
      securityCode.value.length === 4 &&
      isValidPhoneNumber &&
      statusInputPassword.status === STATUS_INPUT.VALID
    ) {
      return false
    }
    return true
  }

  return (
    <ModalCustom
      renderHeader={
        <div className="flex gap-2 items-center">
          <EncryptionLockIcon />
          <Typography
            className="text-base font-semibold"
            style={{
              color: "#222222",
              lineHeight: "26px",
            }}
          >
            Enable data encryption
          </Typography>
        </div>
      }
      bodyChildren={
        <div className="flex flex-col gap-6">
          <div className="flex flex-col">
            <p
              style={{
                color: "#222222",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "24px",
              }}
            >
              With data encryption, all future projects you create will be
              encrypted for enhanced security. Once enabled, data encryption
              cannot be disabled.
            </p>
            <p
              style={{
                color: "#222222",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "24px",
                marginBottom: 12,
              }}
            >
              To enable data encryption, you must verify your identity by
              providing:
            </p>
            <FormInputCard title="Phone number" required>
              <InputPhone
                value={phone.value}
                setValue={handleChangePhoneNumber}
                onEnterKeyPress={onKeyPress}
              />
              {phone.value ? (
                <div className="flex mt-1">
                  <p
                    className="font-semibold"
                    style={{
                      color: isValidPhoneNumber ? "#56A012" : "#EA4545",
                      fontSize: 10,
                      lineHeight: "14px",
                    }}
                  >
                    {isValidPhoneNumber
                      ? "Valid phone number format!"
                      : "Invalid phone number format!"}
                  </p>
                </div>
              ) : null}
            </FormInputCard>
            <FormInputCard title="Set up a passcode" required>
              <InputDefault
                value={securityCode.value}
                onChange={(el) => securityCode.setValue(el.target.value)}
                placeholder="4 characters"
                maxLength={4}
                onKeyPress={onKeyPress}
                type="password"
                isPassword
              />
              <div className="flex flex-col mt-1">
                <p className="text-[#111111] text-[13px] leading-[22px]">
                  Your new recovery code file will be password-protected and
                  sent to you via email. To unlock it, use a code composed of
                  the last 4 digits of your phone number, followed by your
                  4-character passcode.Your passcode may include alphanumeric
                  and special characters, it is case-sensitive.
                </p>
                <p className="font-semibold text-[#111111] text-[13px] leading-[22px]">
                  Format:[Last 4 digits of phone][4-character passcode]
                </p>
                <p className=" text-[#111111] text-[13px] leading-[22px]">
                  Example: If your phone number is 123456 and your passcode is
                  ABCD, the unlock code is 3456ABCD.If your passcode is @$cd,
                  then your unlock code is 1234@$cd
                </p>
                <p className="text-[#111111] text-[13px] leading-[22px]">
                  Please note that your passcode is not stored, and we cannot
                  recover your file if it is lost.
                </p>
              </div>
            </FormInputCard>
            <FormInputCard required title="Current Password">
              <InputDefault
                type="password"
                isPassword
                value={password.value}
                onChange={handleChangeInput}
                onKeyPress={onKeyPress}
                status={statusInputPassword.status}
                labelStatus={statusInputPassword.label}
              />
            </FormInputCard>
          </div>
          <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between">
            <Button
              widthBtn={"100%"}
              title="Close"
              colorBtn="white"
              onClick={onCloseModal}
            />
            <Button
              widthBtn={"100%"}
              title={"Enable"}
              colorBtn="yellow"
              disabled={handleDisableButton()}
              isDisabledBtn
              onClick={() =>
                handleEnableDataEncryption(
                  password.value,
                  phone.value,
                  securityCode.value
                )
              }
            />
          </div>
        </div>
      }
    />
  )
}

const DataEncryptionForm = ({
  forceEncryption = false,
  openModalUpdateSecurityCode,
}: {
  forceEncryption?: boolean
  openModalUpdateSecurityCode: {
    value: boolean
    setValue: (value: boolean) => void
  }
}) => {
  const {
    generateMasterKeyAndPasswordHashed,
    generateVaultKeyAndBackUpKeyAndEncryptedVersion,
  } = encryptionController()
  const userInfo = useAppSelector((state) => state.userInfo)
  const backUpKeyState = useString()
  const securityCodeState = useString()
  const phoneNumberState = useString()
  const openRecoveryModal = useBoolean()
  const openConfirmationModal = useBoolean()
  const openDataEnableEncryptionModal = useBoolean()
  const openGenerateNewRecoveryCodeModal = useBoolean()

  const handleEnableDataEncryption = async (
    password: string,
    phoneNumber: string,
    securityCode: string
  ) => {
    configureStore.dispatch(startLoading())
    setTimeout(async () => {
      try {
        const { masterKey, passwordHash } =
          await generateMasterKeyAndPasswordHashed(password, userInfo.email)
        const publicAndPrivateTemporarily = await Axios.get<{
          data: {
            privateKey: string
            publicKey: string
          }
        }>("/api/auth/decrypt-private-key", {
          params: {
            email: userInfo.email,
          },
        })
        let newPrivateKey = ""
        let newPublicKey = ""
        if (
          publicAndPrivateTemporarily.data.data.privateKey &&
          publicAndPrivateTemporarily.data.data.publicKey
        ) {
          newPrivateKey = publicAndPrivateTemporarily.data.data.privateKey
          newPublicKey = publicAndPrivateTemporarily.data.data.publicKey
        } else {
          const generateKeyLocal = await encryptionHelper.generateKeyPair()
          newPrivateKey = generateKeyLocal.privateKey
          newPublicKey = generateKeyLocal.publicKey
        }

        if (!newPrivateKey || !newPublicKey) {
          toast(
            <LabelNotificationPage
              type="error"
              messenger={"Generate public and private failed!"}
            />
          )
          configureStore.dispatch(endLoading())
          return
        }
        const {
          vaultKey,
          encryptedBackUpkey,
          encryptedKMSBackupKey,
          encryptedVaultkey,
        } = await generateVaultKeyAndBackUpKeyAndEncryptedVersion(masterKey)

        // Create conversation note encryption key
        const encryptedPrivateKey = (await encryptionGCMHelper.encryptContext(
          vaultKey,
          newPrivateKey
        )) as string

        const backupKeyCode = encryptionHelper.createBackupKey()

        const encryptedBackupKeyCode = await encryptionGCMHelper.encryptContext(
          backupKeyCode,
          vaultKey,
          "passphrase"
        )

        const enableEncryptionRequest: EnableEncryptionRequest = {
          password,
          passwordHash,
          encryptedVaultkey,
          encryptedBackUpkey,
          encryptedKMSBackupKey,
          encryptedPrivateKey,
          publicKey: newPublicKey,
          encryptedBackupKeyCode,
          phoneNumber,
        }

        enableEncryptionMiddleware(enableEncryptionRequest)
          .then(async (res) => {
            backUpKeyState.setValue(backupKeyCode)
            securityCodeState.setValue(securityCode)
            phoneNumberState.setValue(phoneNumber)
            postSendRecoveryCodeMiddleware(
              phoneNumber,
              securityCode,
              backupKeyCode,
              userInfo.email,
              userInfo.fullname
            )
            setUserVaultKey(vaultKey)
            setUserMasterKey(masterKey)
            openDataEnableEncryptionModal.setValue(false)
            openRecoveryModal.setValue(true)
            configureStore.dispatch(setUserInfoAction({ is_encrypted: true }))

            toast(
              <LabelNotificationPage
                type="success"
                messenger={MESSENGER_NOTIFICATION.ENABLE_ENCRYPTION_SUCCESS}
              />
            )

            await updateData(Stores.PrivateKeys, {
              privateKey: newPrivateKey,
              id: userInfo.id,
            })
          })
          .catch((error) => {
            toast(
              <LabelNotificationPage
                type="error"
                messenger={error.response?.data.message}
              />
            )
          })
      } catch (error) {
        toast(
          <LabelNotificationPage
            type="error"
            messenger="Generate backup key failed!"
          />
        )
      }
    }, 200)
  }

  const handleAfterGenerateCode = async (
    backupKeyCode: string,
    securityCode: string,
    phoneNumber: string
  ) => {
    openGenerateNewRecoveryCodeModal.setValue(false)
    backUpKeyState.setValue(backupKeyCode)
    securityCodeState.setValue(securityCode)
    phoneNumberState.setValue(phoneNumber)
    openRecoveryModal.setValue(true)
  }

  const onResendEmail = () => {
    postSendRecoveryCodeMiddleware(
      phoneNumberState.value,
      securityCodeState.value,
      backUpKeyState.value,
      userInfo.email,
      userInfo.fullname
    )
  }

  return (
    <div>
      {forceEncryption ? (
        <h4 className="text-sm text-red font-semibold mt-4 mb-4">
          To ensure the highest level of data protection, we require you to
          enable encryption mode before accessing any sensitive information.
          Encryption safeguards your data by scrambling it, making it unreadable
          to unauthorized individuals.
        </h4>
      ) : undefined}
      <div className="flex flex-col">
        {/* <p className="text-sm text-black font-semibold">Data encryption</p> */}

        <div className="flex flex-col mt-2 border border-[#E4E4E4] rounded-[6px] pb-[10px] pt-[10px] pl-[12px] pr-[12px]">
          <div className="flex items-center justify-between h-[24px]">
            <p className="text-sm text-black font-semibold">Data encryption</p>
            {userInfo.is_encrypted ? (
              <div className="pt-[3px] pb-[3px] pl-[8px] pr-[8px] bg-green_opacity_015 rounded-[20px]">
                <p className="text-[#56A012] text-[12px] font-semibold">
                  Enabled
                </p>
              </div>
            ) : (
              <Button
                colorBtn="white"
                sizeBtn="small"
                title="Enable"
                onClick={() => openDataEnableEncryptionModal.setValue(true)}
              ></Button>
            )}
          </div>

          <p className="mt-1">
            All projects will be encrypted for added security. Once enabled,
            encryption cannot be turned off.
          </p>
          {!forceEncryption ? (
            <p
              className="mt-1 text-[#0A5AF5] text-[12px] font-normal cursor-pointer leading-[24px] curr hover:underline"
              onClick={() => openGenerateNewRecoveryCodeModal.setValue(true)}
            >
              Generate new recovery code
            </p>
          ) : null}
        </div>
      </div>
      {openRecoveryModal.value && backUpKeyState.value && (
        <RecoveryModal
          backUpKey={backUpKeyState.value}
          onResendEmail={onResendEmail}
          onClickSubmit={() => {
            downLoadBackUpKey(
              backUpKeyState.value,
              userInfo.email,
              phoneNumberState.value,
              securityCodeState.value
            )
          }}
          onCloseModal={() => {
            if (forceEncryption) {
              openConfirmationModal.setValue(true)
            } else {
              openRecoveryModal.setValue(false)
            }
          }}
        />
      )}

      {openDataEnableEncryptionModal.value && (
        <EnableDataEncryptionModal
          handleEnableDataEncryption={handleEnableDataEncryption}
          onCloseModal={() => openDataEnableEncryptionModal.setValue(false)}
        />
      )}
      {openConfirmationModal.value ? (
        <YesNoModal
          onCancel={() => {
            openConfirmationModal.setValue(false)
          }}
          onConfirm={() => {
            openConfirmationModal.setValue(false)
            openRecoveryModal.setValue(false)
            pushTo(PATH.projectSensitiveData)
          }}
        />
      ) : undefined}
      {openGenerateNewRecoveryCodeModal.value && userInfo.phone_number ? (
        <GenerateNewRecoveryCodeModal
          onCloseModal={() => openGenerateNewRecoveryCodeModal.setValue(false)}
          handleAfterGenerate={handleAfterGenerateCode}
          handleOpenSetupSecurityCode={() => {
            openGenerateNewRecoveryCodeModal.setValue(false)
            openModalUpdateSecurityCode.setValue(true)
          }}
        />
      ) : undefined}
      {openGenerateNewRecoveryCodeModal.value && !userInfo.phone_number ? (
        <WarningSecurityCodeAndPhoneNumberModal
          isGenerateNewRecoveryCode={true}
          handleUpdateSecurityCodeAndPhoneNumber={(currentPassword) => {
            openGenerateNewRecoveryCodeModal.setValue(false)
            pushTo(PATH.updatePhoneNumberAndSecurityCode, undefined, {
              isSuccessPassword: true,
              currentPassword,
            })
          }}
          onCloseModal={() => openGenerateNewRecoveryCodeModal.setValue(false)}
        />
      ) : undefined}
    </div>
  )
}

const TwoFactorSetting = ({
  forceEncryption = false,
}: {
  forceEncryption?: boolean
}) => {
  const userInfo = useAppSelector((state) => state.userInfo)
  const [qrCode, setQRCode] = useState("")
  const { isMobile } = useWindowSize()
  const mfaCode = useString("")
  const isEnableMFA = useBoolean(false)
  const openModalUpdateSecurityCode = useBoolean(false)

  const onUpdateTwoFactor = (type: "enable" | "disable", method: MFAMethod) => {
    if (type === "enable") {
      isEnableMFA.setValue(true)
      umamiTracking(EVENT.ENABLE_2FA)
    }
    settingTwoFactor(type, method).then((res) => {
      if (res.qrCode) {
        setQRCode(res.qrCode)
      }
    })
  }
  const onSubmit = () => {
    if (isEmpty(mfaCode.value)) {
      return toast(
        <LabelNotificationPage
          type="error"
          messenger={"MFA Code is required."}
        />
      )
    }
    verifySettingMFA(
      {
        mfaCode: mfaCode.value,
        isEnable: isEnableMFA.value,
      },
      (typeRes: STATUS_RESPONSE, messenger) => {
        if (typeRes === STATUS_RESPONSE.SUCCESS) {
          setQRCode("")
          mfaCode.setValue("")
        } else {
          toast(
            <LabelNotificationPage messenger={messenger ?? ""} type="error" />
          )
        }
      }
    )
  }

  return (
    <div className="flex flex-col">
      {!forceEncryption ? (
        <EnableTwoFactorForm
          handleSubmit={onUpdateTwoFactor}
          userInfo={userInfo}
        />
      ) : undefined}

      <DataEncryptionForm
        forceEncryption={forceEncryption}
        openModalUpdateSecurityCode={openModalUpdateSecurityCode}
      />
      {!forceEncryption && !isMobile ? (
        <div className="flex flex-col mt-[12px]">
          {/* <p className="text-sm text-black font-semibold">Access keys</p> */}
          <div className="flex flex-col mt-2 border border-[#E4E4E4] rounded-[6px] pb-[10px] pt-[10px] pl-[12px] pr-[12px]">
            <div className="flex items-center justify-between h-[24px]">
              <p className="text-sm text-black font-semibold">Access keys</p>
            </div>

            <p className="mt-1">
              Provide a comprehensive view of all keys shared with invitees in
              the project and build, facilitating the detection and re-sharing
              of missing keys to ensure full access for all invitees.
            </p>
            <p
              className="mt-1 text-[#0A5AF5] text-[14px] font-normal cursor-pointer leading-[24px] curr hover:underline"
              onClick={() => {
                pushTo(PATH.accessKey)
              }}
            >
              View details
            </p>
          </div>
        </div>
      ) : null}

      {!isEmpty(qrCode) ? (
        <ModalCustom
          renderHeader={
            <div className="flex gap-2 items-center">
              <Typography
                className="text-base font-semibold"
                style={{
                  color: "#222222",
                  lineHeight: "26px",
                }}
              >
                Scan the QR code
              </Typography>
            </div>
          }
          bodyChildren={
            <div>
              <Typography
                className="text-sm font-normal"
                style={{
                  color: "#222222",
                }}
              >
                Use the Authenticatior app to scan the QR code. This will
                connect the Authenticator app with your Tracelium account.
              </Typography>
              <img
                style={{ width: 200, height: 200, margin: "16px auto" }}
                src={qrCode}
                alt="qr-code"
              />
              <Typography
                className="text-sm font-normal"
                style={{
                  color: "#222222",
                  paddingBottom: 16,
                }}
              >
                Then put the verification code from the Authenticator app here.
              </Typography>
              <FormInputCard title="MFA Code">
                <InputDefault
                  type="input"
                  value={mfaCode.value}
                  onChange={(e) => {
                    mfaCode.setValue(e.target.value)
                  }}
                />
              </FormInputCard>
              <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between">
                <Button
                  widthBtn={"100%"}
                  title="Cancel"
                  colorBtn="white"
                  onClick={() => {
                    setQRCode("")
                    mfaCode.setValue("")
                  }}
                />
                <Button
                  widthBtn={"100%"}
                  title="Submit"
                  colorBtn="yellow"
                  onClick={onSubmit}
                />
              </div>
            </div>
          }
        />
      ) : null}
    </div>
  )
}
export default TwoFactorSetting
